<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :max-width="290"
  >
    <template v-slot:activator="{ on, attrs }">
      <validation-provider v-slot="{ errors }" :name="fieldName" :rules="rules">
        <v-text-field
          :value="dateDisplay"
          :error-messages="errors"
          :label="label"
          prepend-inner-icon="far fa-calendar-alt"
          v-bind="attrs"
          v-on="on"
          outlined
          dense
          readonly
          :disabled="disabled"
        ></v-text-field>
      </validation-provider>
    </template>
    <v-date-picker
      v-model="dates"
      no-title
      range
      @change="onChange"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { dateLocale } from "@/common/helper"

export default {
  name: "DatePickerRange",
  props: {
    range: {
      type: Boolean,
      default: false,
    },
    "field-name": {
      type: String,
      defalt: "date",
    },
    label: {
      type: String,
      default: "วันที่",
    },
    rules: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    valueDates: {
      type: Array,
      default: () => [],
    }
  },
  mounted() {
    this.initDate()
  },
  data() {
    return {
      dates: [],
      menu: false,
      dateDisplay: "",
    }
  },
  watch: {
    valueDates() {
      this.initDate()
    }
  },
  methods: {
    initDate() {
      if (this.valueDates.length > 1) {
        this.dates = this.valueDates
        this.handleDateDisplay()
      }
    },
    handleDateDisplay() {
      this.dateDisplay = this.dates.map((date) => dateLocale(date)).join(" ~ ")
    },
    onChange() {
      setTimeout(() => {
        this.menu = false
      }, 300)

      this.handleDateDisplay()

      this.$emit("update:date", this.dates)
      this.$emit("change")
    },
  },
}
</script>
